var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",attrs:{"href":_vm.url,"other":_vm.other,"target":_vm.blank}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }